import UrlRule, { firstResult } from './UrlRule';
import safeParseUrl from '../../utils/url/safeParseUrl';

const IMAGE_SOURCES: {
  rules: UrlRule[];
  formatters: { uploadUrl: UrlRule };
}[] = [
  {
    rules: [
      new UrlRule({
        host: ':_.dropbox.com',
        path: '/scl/fi/:id([a-zA-Z0-9]+)/:name.:ext(png|gif|jpg|jpeg|svg)',
        queries: { rlkey: ':rlkey' },
      }),
    ],
    formatters: {
      uploadUrl: new UrlRule({
        host: 'dropbox.com',
        path: '/scl/fi/:id/:name.:ext',
        queries: { raw: '1', rlkey: ':rlkey' },
      }),
    },
  },
];

const matchImage = (payload: string) => {
  const url = safeParseUrl(payload);
  if (!url) return payload;
  const uploadUrl = firstResult(IMAGE_SOURCES, (source) => {
    const matched = firstResult(source.rules, (rule) => rule.match(url));
    return matched ? source.formatters.uploadUrl.format(matched) : null;
  });
  if (uploadUrl) {
    return uploadUrl;
  }
  return payload;
};

export default matchImage;
